import SimplePageHeading from "@/app/components/ui/PageHeadings/SimplePageHeading";
import RBACFlag from "@/app/components/core/RBACFlag";
import CatalogDetailsFormComponent from "./CatalogDetailsFormComponent";
import GeneralDetailsFormComponent, { IInventoryFormFields } from "./GeneralDetailsFormComponent";
import { useState } from "react";
import { useForm } from "react-hook-form";

const ProductAddComponent = () => {
  const [_parentTitleId, setParentTitleId] = useState<string | null>(null);

  const formHook = useForm<IInventoryFormFields>({
    mode: "onChange",
    defaultValues: {
      isproductParent: "no",
      is_pack: false,
      upcs: [{ upcname: "", image_url: null }],
      lots: [{ lot_number: "", mrp: null, date: "" }],
      appVisible: false,
      productForm: "dry",
      age_range: "puppy",
      packs: [{ pack: "", highlight: false, visible: false }],
    },
  });

  return (
    <div>
      <div className="bg-white px-4 py-2 rounded-md">
        <SimplePageHeading title="Product Setup" description="Setup a product along with it's crucial details." />
      </div>
      <div className="bg-white px-4 py-2 rounded-md" id="general-details">
        <RBACFlag actionId="PRODUCT_SETUP">
          <GeneralDetailsFormComponent formHook={formHook} onParentTitleIdChange={setParentTitleId} />
        </RBACFlag>
      </div>
      <div id="catalogue-details">
        <RBACFlag actionId="CATALOGUE_SETUP">
          <CatalogDetailsFormComponent formHook={formHook} />
        </RBACFlag>
      </div>
    </div>
  );
};

export default ProductAddComponent;
